<template>
  <v-overlay opacity="0.8" v-model="active" z-index="10" class="overlay-item" color="#ffffff">
    <div style="min-width: 200px;">
      <v-progress-circular
        style="width: 100%; color: purple;"
        indeterminate
        size="100"
        width="7"
      ></v-progress-circular>
      <div style="color: purple; padding-top: 20px; text-align: center;">{{ title }}</div>
    </div>
  </v-overlay>
</template>

<script>
import { sync } from "vuex-pathify";

export default {
  name: "Loader",
  computed: {
    ...sync('loader', [
      'active',
      'title'
    ])
  }
}
</script>

<style lang="scss" scoped>
.overlay-item {
  font-family: "Roboto", sans-serif;
  color: purple;
  font-size: 20px;
}

</style>
